import {getProductTopSection} from 'modules/product-card/helpers';
import {IProductShort} from 'modules/products/types';

export const getTopSection = (sections: IProductShort['sections']) =>
    sections?.map(getProductTopSection).find((section) => section?.isTop)?.code ?? sections?.[0]?.code;
